import { CalculationRuleSummary } from 'app/api/tag-queries/types';

type CalcConcept = CalculationRuleSummary['parentConcept'];

export interface CalcNode {
  concept: CalcConcept;
  weight: number | null;
  children: CalcNode[];
}

export interface CalcTreeGroup {
  linkroleUri: string | null;
  roleDefinition: string | null;
  roots: CalcNode[];
}

export type CalcTreeByElr = CalcTreeGroup[];

interface ElrBucket {
  roleDefinition: string | null;
  rulesByParent: Map<string, CalculationRuleSummary>;
  summandIds: Set<string>;
}

function buildNode(concept: CalcConcept, weight: number | null, rulesByParent: Map<string, CalculationRuleSummary>, visited: Set<string>): CalcNode {
  const childRule = rulesByParent.get(concept.id);
  let children: CalcNode[] = [];
  if (childRule) {
    const nextVisited = new Set(visited);
    nextVisited.add(concept.id);
    children = childRule.summands.filter((s) => !nextVisited.has(s.concept.id)).map((s) => buildNode(s.concept, s.weight, rulesByParent, nextVisited));
  }
  return { concept, weight, children };
}

export function buildCalcTree(rules: CalculationRuleSummary[]): CalcTreeByElr {
  const byElr = new Map<string | null, ElrBucket>();

  for (const rule of rules) {
    let bucket = byElr.get(rule.linkroleUri);
    if (!bucket) {
      bucket = { roleDefinition: rule.roleDefinition, rulesByParent: new Map(), summandIds: new Set() };
      byElr.set(rule.linkroleUri, bucket);
    }
    bucket.rulesByParent.set(rule.parentConcept.id, rule);
    rule.summands.forEach((s) => bucket!.summandIds.add(s.concept.id));
  }

  const groups: CalcTreeByElr = [];
  byElr.forEach((bucket, linkroleUri) => {
    const roots: CalcNode[] = [];
    bucket.rulesByParent.forEach((rule) => {
      if (bucket.summandIds.has(rule.parentConcept.id)) return;
      roots.push(buildNode(rule.parentConcept, null, bucket.rulesByParent, new Set()));
    });
    groups.push({ linkroleUri, roleDefinition: bucket.roleDefinition, roots });
  });

  return groups;
}
